import Reveal from '../animation/Reveal';

function PageFrame({ eyebrow, title, children }) {
  return (
    <section className="page-frame">
      <Reveal className="page-title">
        <p className="section-label">{eyebrow}</p>
        <h1>{title}</h1>
      </Reveal>
      {children}
    </section>
  );
}

export default PageFrame;
